import React, {useContext, useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import useApi from '../Hooks/useApi'
import Loader from '../Components/Loader'
import utilities from '../utilities'
import {AuthContext} from '../context/AuthContext'
import swal from 'sweetalert'


const Admissions = (props) => {
    const navigate = useNavigate();
    const {userInfo} = useContext(AuthContext);
const {data} = useApi( {url: '/Exam/GetCompletedApplications', method: 'get' });

const ChangeExamCenter =(student) => {
    var registrationID = utilities.encryptData(student.registrationID.toString());
    var yearID = utilities.encryptData(student.yearID.toString());
    var candidateID = utilities.encryptData(student.candidateID.toString());
    navigate('/exam/application/' + registrationID + '/' + yearID + '/' + candidateID );
}



const Apply = (student) => {

    var registrationID = utilities.encryptData(student.registrationID.toString());
    var yearID = utilities.encryptData(student.yearID.toString());
    var candidateID = utilities.encryptData(student.candidateID.toString());



    if (student.yearID == 2)
    {
        utilities.getData( {url: '/Exam/CheckIfAppearedInFirstYear?RegNo=' + student.registrationNo, jwt: userInfo.jwt}).then(isAppeared => {
            if (isAppeared)
            {
                navigate('/exam/application/' + registrationID + '/' + yearID + '/' + candidateID );
            }
            else
            {
                swal({
                    title: "Attention!",
                    text: 'The student has not applied or appeared in the First Year Exam Yet. Please Apply for 1st Year first then you can apply for 2nd Year.',
                    icon: "info",
                  });
            }

        });
        
        
            //const {data: isAppearedInFirstYear} = useApi( {url: '/Exam/CheckIfAppearedInFirstYear', method: 'get', callback: CheckIfAppearedInFirstYear(student.studentID,student.yearID ) });

        // CheckIfAppearedInFirstYear
        //If not appeared in FirstYear
            //Alert (Please apply for 1st Year and then you can apply for second year)
        //else, 

        // var firstYearCategory = getObjects(data[1], 'name', student.category);
        // if (firstYearCategory && firstYearCategory.length > 0)
        // {
        //     var isNotAppearedInFirst = firstYearCategory[0].students.filter(_student => _student.studentID == student.studentID).length > 0;
        //     if (isNotAppearedInFirst)
        //     {
        //         alert('The candidate is not appeared in first year. Please apply for 1st Year and then you can apply for second year');
        //     }
        //     else
        //     {
        //         alert('All Ok! ready to proceed');
        //     }    
        // }
        // else
        // {
        //     alert('category' + student.category + ' not exists in 1st Year');
        // }
    }
    else
    {
        navigate('/exam/application/' + registrationID + '/' + yearID + '/' + candidateID );
        //setUserName(student.studentID, student.yearID, student.category, "IRFAN IBRAHIM");
    }
    
  }

  

  return (
    <>
    {!data ? (<Loader />) : (

    
                            <div className="content">
                                <div className="header">
                                    <label className="title"> Admissions Confirmed </label>
                                </div>
                                <div className="body">
                                    <div className="animate-bottom">
                                        {data.map((exam, key) => {
                                            return (
                                                <>
                                                    <div style={{textAlign: 'center'}}>
                                                        <h3 key={key}> {exam.yearID == 0 ? 'Old Scheme' : exam.yearID == 1 ? '1s Year' : '2nd Year'} </h3>  
                                                    </div>
                                                    {exam.category.map((category, index) => {
                                                        return (
                                                            <div className="table-responsive"> 
                                                            <table className='table table-striped table-hover table-bordered caption-top'>
                                                                <caption >
                                                                    <span key={index}> {category.name} </span>
                                                                </caption>
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th>Session</th>
                                                                        <th>Registration No.</th>
                                                                        <th>Student Name</th>
                                                                        <th>Father Name</th>
                                                                        <th>Category</th>
                                                                        <th>Exam Center</th>
                                                                        <th>Action</th>

                                                                    </tr>
                                                                </thead>
                                                                
                                                                <tbody>

                                                                {category.students.map((student) => {
                                                                    return (
                                                                        <>
                                                                            <tr key={student.candidateID}>
                                                                                <td>{student.session}</td>
                                                                                <td>{student.registrationNo}</td>
                                                                                <td>{student.studentName}</td>
                                                                                <td>{student.fatherName}</td>
                                                                                <td>{student.category}</td>
                                                                                <td>{student.examCityName}</td>
                                                                                <td style={{textAlign: 'center'}}> 
                                                                                     {/* <button className='btn btn-primary' onClick={() => Apply(student)} > Apply </button> */}
                                                                                {userInfo.showCoveringLetter ? (null) : (
                                                                                        <button className='btn btn-primary' onClick={() => ChangeExamCenter(student)} > Change Exam Center </button>
                                                                                    )
                                                                                }

                                                                                     
                                                                                </td>                                                                                
                                                                            </tr>
                                                                        </>
                                                                    )
                                                                  })
                                                                }
                                                                </tbody>
                                                        </table>
                                                        </div>
                                                        );

                                                    })
                                                    }
                                                </>
                                            );
                                        })}

                                    </div>


                                    
                                </div>
                            </div>
        )
    }
    </>
  );

};

export default Admissions;